export default "__VITE_ASSET__Bxdut5Ae__"